import { useCallback, useState } from "react";
import { CREDIT_PACKAGE_IDS } from "../lib/creditConstants";

export function useCreditManager() {
  const [creditBalance] = useState(0);
  const refreshBalance = useCallback(async () => 0, []);
  const refreshPackages = useCallback(async () => {}, []);
  const refreshAll = useCallback(async () => {}, []);
  const purchase = useCallback(async () => ({ success: false, error: "web_stub" }), []);
  const retryPendingVerify = useCallback(async () => ({ success: false }), []);
  const applyCreditBalance = useCallback(() => {}, []);
  const getPackagePrice = useCallback(() => null, []);
  const getCreditsForPackage = useCallback(() => 0, []);

  return {
    creditBalance,
    balanceLoading: false,
    balanceLoaded: true,
    applyCreditBalance,
    packages: {},
    packagesLoading: false,
    isProcessing: false,
    isAuthenticated: false,
    hasCredits: false,
    needsTopUp: false,
    isIapAvailable: false,
    refreshBalance,
    refreshPackages,
    refreshAll,
    purchase,
    retryPendingVerify,
    getPackagePrice,
    getCreditsForPackage,
    packageKeys: CREDIT_PACKAGE_IDS,
  };
}
